 <div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
    <div style="min-width:370px;max-width: 100%;">
      <div class="flexStart">
      <p class="tileTitle" style="margin-bottom: 5px;">{{'Application Overview' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
     </div>
    
      <div class="text-center padT30"> 
     
      <div class="text" *ngIf="appOverviewData.length==0">{{'No data' | translate}}</div>
      <div class="chartContainer" disabled [ngClass]="appOverviewData.length==0 ? 'chartDisabled':''" [dir]="textDir">          
      <div id="appdonut" [dir]="textDir" >{{'Chart' | translate}}</div>
    </div>
      </div>
    
    </div>
    <div class="verticalLine" style="text-align:center;"></div>
    <div style="width:100%" >
      <div class="text" *ngIf="sumofApplicationItems[0].usage_hours==0">{{'No data' | translate}}</div>
      <div class="chartContainer" [ngClass]="sumofApplicationItems[0].usage_hours==0 ? 'chartDisabled':''">    
        <div id="appOverview" class="content" style=" margin-top: 24px;height:37px" [ngClass]="textDir=='rtl'?'pull-right marL5':'pull-left marR5'" [dir]="textDir">
          <table class="table" [dir]="textDir" [ngClass]="textDir=='rtl'?'marR5':'marL5'">
            <thead style="color: #f2f2f2;">
              <tr style="color: #f2f2f2;opacity: 0.6;font-size: 12px;">             
                <th style="width:150px;">{{'Application' | translate}}</th>
                <th class="center" style="width:150px;text-align: center;">{{'Usage Hours' | translate}}</th>
                <th class="center" style="width:150px;text-align: center;">{{'Individual Users' | translate}}</th>              
              </tr>
            </thead>
          </table>
        </div>
        <div class="content" id="appOverviewBody"  style="display: inline-block; margin-top: 3px !important;height:250px;overflow-y: auto;scrollbar-width: thin;" [ngClass]="textDir=='rtl'?'marL5':'marR5'" [dir]="textDir">
          <table class="table dashed" [dir]="textDir" >           
            <tbody style="background-color: black; font-size:12px;">
              <tr *ngFor="let item of sumofApplicationItems; let i=index" [attr.data-index]="i">              
                <ng-container >
                  <td style="width:150px;"><span style="font-size: 14px;" [ngClass]="textDir=='rtl'?'pull-right marL5':'pull-left marR5'" class="{{'colorData-'+(i+1)}}"><i class="icon icon-alarm-level5" ></i></span>{{item?.id}}</td>
                  <td class="center" style="width:150px;">{{item?.usage_hours}}</td>
                  <td class="center" style="width:150px;">{{item?.user_count}}</td>
                </ng-container>             
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</div>
<div style="width: 20px;margin-top:2px;text-align: right;">

  <div #appoverviewdrop class="dropdown more" data-type="click">
    <button class="btn clickable"><i class="icon icon-more"></i></button>
    <div class="menu right">
      <div class="item" tabindex="0" (click)="generateCSV('application-overview')">{{'Export Panel Data(csv)' | translate}}</div>
     <!--  <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div> -->
    </div>
  </div>
</div>
  </div>
</div>

<br>

<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
    <div class="sm-11">
        <div class="flexStart">
            <p class="tileTitle" style="margin-bottom: 5px;">{{'App usage daily trend' | translate}}</p>
            <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
        </div>
            <ng-container >
               <!--  <div class="content" style="margin: auto; text-align: center;">
                 
                  <div class="labels" style="display: flex;justify-content: center;">
                    <div style="margin-right: 20px;margin-left:0px;display: inline;" *ngFor="let item of appUseTrendChartData; let i = index" [attr.data-index]="i">
                      <div style="display: inline;" [style.color]="appUseTrendChartSetting?.colors[i]"><i class="icon icon-alarm-level5"></i></div> <div class="devices" style="display: inline;" >{{item?.id}}</div>
                    </div>             
                  </div>

                </div> -->
               <!--  <div style="display: inline-block;;">
                  <div class="verticalTxt" style="margin-top:100px;margin-left:20px;">Number of Users</div>
                  <div style="margin-top:-200px;margin-left:30px;text-align: center;color: #181818; font-family: Ericsson Hilda;" id="appUseTrendChart" [ctlLineChart]='appUseTrendChartSetting' [ctlLineData]='appUseTrendChartData'>
                  </div> 
                </div> -->

          </ng-container>
         <div class="padT30">
          
           <div class="text" *ngIf="appUseTrendChartData.length==0">{{'No data'|translate}}</div>
           <div class="chartContainer" [ngClass]="appUseTrendChartData.length==0 ? 'chartDisabled':''">          
           <div id="applineChart">{{'Chart'|translate}}</div>
         </div>
          </div> 
        </div>
    </div>
        <div style="width: 20px;text-align: right;">
          <div #appdailytrenddrop class="dropdown more" data-type="click">
              <button class="btn clickable"><i class="icon icon-more"></i></button>
              <div class="menu right">
                <div class="item" tabindex="0" (click)="generateCSV('application-trend')">{{'Export Panel Data(csv)'|translate}}</div>
                <!-- <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)'|translate}}</div> -->
                <!-- <hr>
                <div class="item space-between">
                  <div>Settings</div>
                  <div><i class="icon icon-settings"></i></div>
                </div> -->
              </div>
            </div>
      </div>
    </div>
  </div>

<br>

<div class="tile" [dir]="textDir" style="overflow-y: auto;height: auto;scrollbar-width: thin;">
  <div class="row" style="display: flex;justify-content: space-between;"> 
    <div style="width:97%;">

      <div class="text" *ngIf="sumofAppInventoryData[0].no_of_installs==0">{{'No data' | translate}}</div>
    <div class="sm-11 chartContainer" [ngClass]="sumofAppInventoryData[0].no_of_installs==0 ? 'chartDisabled':''">
      <div class="flexStart">
      <p class="tileTitle" style="margin-bottom: 5px;">{{'App Inventory' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
      </div>
      <div id="inventory" style="margin-left: 30px;height: 37px;" [dir]="textDir">
      <table class="inventoryTable table sortable" style="overflow-y: auto;height: auto;scrollbar-width: thin;" [dir]="textDir">
        <thead style="color: #f2f2f2; opacity: 0.6;">
          <tr>
            <th class="is-sortable sortTable" (click)="sortTable('inventoryTable',0)">{{'Software' | translate}}</th>
            <th class="is-sortable" (click)="sortTable('inventoryTable',1)">{{'Version' | translate}}</th>
            <th class="is-sortable" (click)="sortTable('inventoryTable',2)">{{'OS' | translate}}</th>
            <th class="is-sortable" (click)="sortTable('inventoryTable',3)">{{'Platform' | translate}}</th>
            <th class="is-sortable" (click)="sortTable('inventoryTable',4)" >{{'Installs' | translate}}</th>
          </tr>
        </thead>
      </table>
    </div>
      <div id="inventorybody" class="content" style="display: inline-block;margin-top:5px;margin-left: 30px;height: 300px;overflow-y: auto;scrollbar-width: thin;" [dir]="textDir">
        <table class="inventoryTable table sortable" style="overflow-y: auto;height: auto;scrollbar-width: thin;" [dir]="textDir">
         
          <tbody style="background-color: black; font-size:12px;">
            <tr *ngFor="let item of sumofAppInventoryData">
              <td>{{item.app_name}}</td>
              <td style="padding-left: 30px;">{{item.app_version}}</td>
              <td >{{item.os_name}}</td>
              <td >{{item.device_type}}</td>
              <td style="text-align: center;">{{item.no_of_installs}}</td>
            </tr>
          </tbody>
        </table>          
      </div>
    </div>
  </div>
   
      <div  style="width: 20px;">
        <div #appinventorydrop class="dropdown more" data-type="click">
          <button class="btn clickable"><i class="icon icon-more"></i></button>
          <div class="menu right">
            <div class="item" tabindex="0" (click)="generateCSV('application-inventory')">{{'Export Panel Data(csv)' | translate}}</div>
           <!--  <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div> -->
          
          </div>
        </div>
      </div>
   
  </div>
</div>
